// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3msxp","buttons":"PendingPaymentAlert_buttons__2VgID"};